/*
Sohel  10/06/2022  3075414077  Fixed Client Maintainance Bugs
Saikrishna 09/21/2022  2698754100  Fixed jira bugs in client maintenance.jira
Suresh Peddavoora 10/30/2022 2698754100  Added Class Name for Text Fields and Buttons
Ashraf 11/15/2022 2698754100 fixed role based bugs
*/
import React, {useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {Controller} from 'react-hook-form';
import {useLocation} from 'react-router';
import PageLoader from '../../../components/PageLoader';
import formatPhoneNumber from '../../../util/PhoneFormat';
import {CONTACT_TYPE} from '../../../constants/Lookup';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {PhoneMaskCustom} from '../../../util/PhoneMaskFormat';
import {postParentCintactInfo} from '../../../redux/reducers/ParentClientContactInfo';
import {ThemeContext} from '../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
const ClientContactForm = ({
  rowData,
  formData,
  setTableData,
  setContactInfoData,
  tableData,
  isEditMode,
  parentClientID,
}) => {
  const {dropDownData} = useSelector(({clientContact}) => clientContact);
  const {isLoading} = useSelector(({parentClientContactInfo}) => parentClientContactInfo);
  const dispatch = useDispatch();
  const location = useLocation();
  const {reusableInputStyles} = useContext(ThemeContext);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.PC;
  const parentTableData = location?.state?.parentData && location.state.parentData;
  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    return label;
  };
  const getObject = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const [currentRuleCode, setCurrentRuleCode] = useState(
    rowData?.contactEmailAddress?.trim() || '',
  );

  const initialValues = {
    contactType: rowData?.contactType ? getObject(rowData.contactType, CONTACT_TYPE) : {},
    contactName: rowData?.contactName ? rowData.contactName : '',
    contactPhoneNumber: rowData?.contactPhoneNumber ?
      formatPhoneNumber(rowData.contactPhoneNumber) :
      '',
    contactEmailAddress: rowData?.contactEmailAddress ? rowData.contactEmailAddress : '',
    contactFaxNumber: rowData?.contactFaxNumber ? formatPhoneNumber(rowData.contactFaxNumber) : '',
  };
  const validationSchema = Yup.object().shape({
    contactType: Yup.object()
      .test('contactType', 'Contact Type is required', (val) => {
        return val?.value;
      })
      .nullable(),
    contactName: Yup.string()
      .trim('The contact name cannot include leading and trailing spaces')
      .required('Name is required')
      .max(50, 'Name cannot exceed 50 characters')
      .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field '),
    contactEmailAddress:
      Yup.string()
        .required('Email Address is required')
        .email('Email is invalid'),

    contactPhoneNumber: Yup.string().test('phone', 'Invalid Phone Number', (value) => {
      value = value && value.replace(/[^\d]/g, '');
      if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
        return true;
      }
    }),
    contactFaxNumber: Yup.string().test('phn', 'Invalid Fax Number', (value) => {
      value = value && value.replace(/[^\d]/g, '');
      if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
        return true;
      }
    }),
  });
  const {handleSubmit, errors, control, setValue, reset} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const classes = reusableInputStyles();
  const onSubmit = (data) => {
    if (data) {
      const values = {
        contactEmailAddress: data?.contactEmailAddress,
        contactFaxNumber: data?.contactFaxNumber,
        contactName: data?.contactName,
        contactPhoneNumber: data?.contactPhoneNumber,
        contactType: data?.contactType?.value ? data?.contactType?.value : '',
        parentClientId: parentTableData?.parentClientId || parentClientID,
        parentContactId: null,
        phoneNumber: data?.contactPhoneNumber,
      };
      if (isEditMode) {
        const editData = {...values, parentContactId: rowData?.parentContactId};
        dispatch(postParentCintactInfo(editData));
      } else {
        dispatch(postParentCintactInfo(values));
      }
      if (rowData?.clientId === 0 || rowData?.clientId) {
        const filterIndex = tableData.findIndex((item) => rowData.clientId === item.clientId);
        const filteredData = [...tableData];
        filteredData[filterIndex] = values;
        setTableData(filteredData);
      } else {
        setTableData((state) => [...state, values]);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="col-md-12">
          <div className="form-row global-field-textfields">
            <div className="col-md-6 col-sm-6 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  required
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        option: classes.option,
                      }}
                      id="contactType"
                      options={getOptions(CONTACT_TYPE)}
                      size="small"
                      autoHighlight
                      getOptionDisabled={(option) => option.value === null}
                      getOptionLabel={(option) => {
                        return option.key === 'none' ? option.value : option.value;
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Contact Type"
                          required
                          name="contactType"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={errors && errors?.contactType?.message}
                          placeholder="Select Contact Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="contactType"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.contactType?.message ? errors.contactType.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-6  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Name"
                    margin="dense"
                    name="contactName"
                    value={value}
                    variant="outlined"
                    label="Name"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactName', e.target.value);
                    }}
                    required
                    error={errors && errors?.contactName?.message}
                    fullWidth
                  />
                )}
                control={control}
                name="contactName"
              />
              <FormHelperText variant="outlined">
                {errors.contactName?.message ? errors.contactName.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-6  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Email Address"
                    margin="dense"
                    name="contactEmailAddress"
                    value={value}
                    variant="outlined"
                    label="Email Address"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setCurrentRuleCode(e?.target?.value?.trim());
                      setValue('contactEmailAddress', e.target.value);
                    }}
                    required
                    error={
                      errors &&
                      errors?.contactEmailAddress?.message &&
                      !(rowData?.contactEmailAddress === currentRuleCode && isEditMode)
                    }
                    fullWidth
                  />
                )}
                control={control}
                name="contactEmailAddress"
              />
              {!(rowData?.contactEmailAddress === currentRuleCode && isEditMode) ? (
                <FormHelperText variant="outlined">
                  {errors.contactEmailAddress?.message ? errors.contactEmailAddress.message : ''}
                </FormHelperText>
              ) : null}
            </div>
            <div className="col-md-6  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Phone Number"
                    margin="dense"
                    name="contactPhoneNumber"
                    variant="outlined"
                    label="Phone Number"
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactPhoneNumber', e.target.value);
                    }}
                    error={errors && errors.contactPhoneNumber?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    InputProps={{
                      inputComponent: PhoneMaskCustom,
                    }}
                  />
                )}
                control={control}
                name="contactPhoneNumber"
              />
              <FormHelperText variant="outlined">
                {errors.contactPhoneNumber?.message ? errors.contactPhoneNumber.message : ''}
              </FormHelperText>
            </div>
            <div className="col-md-6  col-sm-6 form-group">
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Fax Number"
                    margin="dense"
                    name="contactFaxNumber"
                    variant="outlined"
                    label="Fax Number"
                    error={errors && errors.contactFaxNumber?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('contactFaxNumber', e.target.value);
                    }}
                    InputProps={{
                      inputComponent: PhoneMaskCustom,
                    }}
                  />
                )}
                control={control}
                name="contactFaxNumber"
              />
              <FormHelperText variant="outlined">
                {errors.contactFaxNumber?.message ? errors.contactFaxNumber.message : ''}
              </FormHelperText>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center ">
          <Button
            type="button"
            variant="outlined"
            className={`mx-1 reset-btn ${classes.buttonRoot}`}
            onClick={() => {
              reset(initialValues);
              setCurrentRuleCode(rowData?.contactEmailAddress?.trim() || '');
            }}

          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="outlined"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            disabled={(!disabledByRole?.edit && parentTableData?.parentClientId) || !disabledByRole?.add}
          >
            {isEditMode ? 'Edit' : 'Add'}
          </Button>
        </div>

        {isLoading && <PageLoader />}
      </form>
      {/* {isLoading && <PageLoader />} */}
    </div>
  );
};

export default ClientContactForm;
